import { useMutation } from '@apollo/client';
import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { CreateTag } from '../../../graphql/Mutation';
import toast from 'react-hot-toast';

export default function CreatableAsyncCustom({
  theme,
  disabled = false,
  setOptions,
  values,
  type
}) {
  const [createTag] = useMutation(CreateTag);
  const handleChange = (value) => {
    setOptions(type, value);
  };

  const handleNewOption = async (value) => {
    const item = {
      name: value,
      type,
      active: true
    };

    const {
      data: { createTag: data }
    } = await createTag({
      variables: {
        createTagInput: item
      }
    });

    item._id = data._id;
    setOptions(type, [...values, item]);
  };

  return (
    <CreatableSelect
      className="react-select"
      classNamePrefix="select"
      name="callback-react-select"
      isClearable={false}
      isMulti
      getOptionLabel={(e) => e.name}
      getOptionValue={(e) => e._id}
      onCreateOption={handleNewOption}
      isSearchable
      onChange={handleChange}
      noOptionsMessage={() => 'Ya existe una opcion'}
      value={values}
      isValidNewOption={(inputValue, value) => {
        const exist = value.find(
          (val) => val.name.toLowerCase() === inputValue.toLowerCase()
        );

        if (exist) {
          toast.error('Ya existe esta opcion');
          return false;
        }

        return true;
      }}
      formatCreateLabel={(userInput) => `Search for ${userInput}`}
      theme={theme}
      isDisabled={disabled}
    />
  );
}
